import {
  createUrlResolver,
  HOMEPAGE_LANGUAGE_OVERRIDE_PATH,
  type Language,
  type SiteName,
} from '@seek/melways-sites';

import { isAbsoluteUrl } from './isAbsoluteUrl';
import { isLocalisedPath } from './isLocalisedPath';

const HOMEPAGE_PATHS = ['/', '/en', '/id', '/th'];

export const getLocalizedHrefHelper = ({
  language,
  site,
}: {
  language: Language;
  site: SiteName;
}) => {
  const urlResolver = createUrlResolver({
    site,
    language,
  });

  return function (href: string): string {
    const isHomePath = HOMEPAGE_PATHS.includes(href);
    if (
      (!isAbsoluteUrl(href) && !isLocalisedPath({ path: href, language })) ||
      isHomePath
    ) {
      const targetPath = isHomePath ? HOMEPAGE_LANGUAGE_OVERRIDE_PATH : href;

      return urlResolver({
        path: targetPath,
      });
    }
    return href;
  };
};
